module.exports = __webpack_public_path__ + "img/home_recom_relaxed.ffbb1042.png";